const getQueryValue = (value) => Array.isArray(value)
    ? value.map(val => encodeURIComponent(val)).join(',')
    : encodeURIComponent(value);
export const getQueryString = (queryParameters) => Object.entries(queryParameters).reduce((accumulator, [key, value], index) => `${accumulator}${index === 0 ? '?' : '&'}${encodeURIComponent(key)}=${getQueryValue(value)}`, '');
//# sourceMappingURL=query.js.map